import { AxiosRequestConfig } from "axios";
import { stringify } from "query-string";
import { httpPost } from "shared/api/apiHandler";
import { CONTENT_TYPES, getClientId, getClientSecret, GRANT_TYPES } from "shared/api/auth/constants";
import urls from "shared/api/auth/urls";
import { AuthMethod } from "shared/constants/enums";
import AuthResponse from "shared/models/authResponse";

export const loginByCode = (username: string, code: number): Promise<AuthResponse> => {
    const data = {
        username,
        code,
        authMethod: AuthMethod.Sms,
        grant_type: GRANT_TYPES.SMS_CODE,
        client_id: getClientId(),
        client_secret: getClientSecret(),
    };

    return connectToken(data);
};

export const loginByToken = (token: string): Promise<AuthResponse> => {
    const data = {
        token,
        authMethod: AuthMethod.Email,
        grant_type: GRANT_TYPES.EMAIL_TOKEN,
        client_id: getClientId(),
        client_secret: getClientSecret(),
    };

    return connectToken(data);
};

export const refreshAccessToken = (refreshToken: string): Promise<AuthResponse> => {
    const data = {
        refresh_token: refreshToken,
        grant_type: GRANT_TYPES.REFRESH_TOKEN,
        client_id: getClientId(),
        client_secret: getClientSecret(),
    };

    return connectToken(data);
};

const connectToken = async (data: Record<string, string | number>): Promise<AuthResponse> => {
    const config: AxiosRequestConfig = {
        headers: { "Content-Type": CONTENT_TYPES.X_WWW_FORM_URLENCODED },
    };
    const encodedData = stringify(data);

    const response = await httpPost<{ access_token: string; refresh_token: string }, string>(
        window.APP_SETTINGS.authApiBaseUri,
        urls.CONNECT.TOKEN,
        encodedData,
        config
    );

    return {
        accessToken: response.data.access_token,
        refreshToken: response.data.refresh_token,
    };
};
